import { ACTIVE_CORGANIZATION } from './apiModules'

import { post } from '@/utils/request'

export function getActiveOrganizationList(params) {
  return post(`${ACTIVE_CORGANIZATION}/getCustomerBaseInfo`, params)
}

export function getTerminalDeployInfo(params) {
  return post(`${ACTIVE_CORGANIZATION}/getTerminalDeployInfo`, params)
}

export function getRepurchaseInfo(params) {
  return post(`${ACTIVE_CORGANIZATION}/getRepurchaseInfo`, params)
}

export function getWebBehaviorInfo(params) {
  return post(`${ACTIVE_CORGANIZATION}/getWebBehaviorInfo`, params)
}

export function getBehaviorDetail(params) {
  return post(`${ACTIVE_CORGANIZATION}/getCustomerWebBehavior`, params)
}

export function getSingleBehaviorDetail(params) {
  return post(`${ACTIVE_CORGANIZATION}/getAdminEachBehavior`, params)
}

export function getFirstLoginBehavior(params) {
  return post(`${ACTIVE_CORGANIZATION}/getFirstLoginBehavior`, params)
}

export function getTradeInfo(params) {
  return post(`${ACTIVE_CORGANIZATION}/getTradeInfo`, params)
}

// 获取客户的组织代运维关系
export function getMaintainOrgs(params) {
  return post(`${ACTIVE_CORGANIZATION}/getAgencyOrg`, params)
}

export function getTerminalDistributeStatics(params) {
  return post(`${ACTIVE_CORGANIZATION}/getTerminalIpStatisticInfo`, params, 180000)
}

export function getTerminalBehaviorDetail(params) {
  return post(`${ACTIVE_CORGANIZATION}/getCustomerTerminalBehavior`, params)
}

export function getBehaviorByTerminal(params) {
  return post(`${ACTIVE_CORGANIZATION}/getShineBehaviorByTerminalName`, params)
}

export function getTerminalBehaviorRank(params) {
  return post(`${ACTIVE_CORGANIZATION}/getShineBehaviorStatistic`, params)
}

// 获取渠道的订单详情
export function getOrderDetail(params) {
  return post(`${ACTIVE_CORGANIZATION}/getOrderInfo`, params)
}

// 获取终端列表
export function getTerminalList(params) {
  return post(`${ACTIVE_CORGANIZATION}/getTerminalList`, params)
}

// 获取终端分组
export function getTerminalGroup(params) {
  return post(`${ACTIVE_CORGANIZATION}/getTerminalGroupName`, params)
}
